import React from 'react';
import { Helmet } from 'react-helmet';
import { FaAward } from '@react-icons/all-files/fa/FaAward'
import CardAccueil from '../../components/anonymous/accueil/CardAccueil';
import CardRecemmentInscrit from '../../components/anonymous/accueil/CardRecemmentInscrit';
import PanelRead from '../../components/commons/PanelRead';
import SearchBar, { SearchBarVariants } from '../../components/commons/SearchBar';
import { EnumTypeEtablissement, EnumTypeMedecin, EnumTypeService, EnumWilaya } from '../../utils/generated/Constants';
import { MinDesktop, useMinDesktopQuery } from '../../utils/MediaQueries';
import './PageAccueil.css';


const wilayas = Object.keys(EnumWilaya).slice(0, 50).map(function (item, index) {
    return {
        url: '/wilaya/' + EnumWilaya[item].Code + '/' + EnumWilaya[item].UrlFormate,
        libelle: (EnumWilaya[item].Code + '').padStart(2, '0') + ' - ' + EnumWilaya[item].Libelle
    }
}).sort((a, b) => a.libelle.localeCompare(b.libelle));


const specialite = Object.keys(EnumTypeMedecin).slice(0, 100).map(function (item, index) {
    return {
        url: '/medecin/type/' + EnumTypeMedecin[item].Code + '/' + EnumTypeMedecin[item].UrlFormate,
        libelle: EnumTypeMedecin[item].Libelle
    }
}).sort((a, b) => a.libelle.localeCompare(b.libelle));


const etablissements = Object.keys(EnumTypeEtablissement).slice(0, 40).map(function (item, index) {
    return {
        url: '/etablissement/type/' + EnumTypeEtablissement[item].Code + '/' + EnumTypeEtablissement[item].UrlFormate,
        libelle: EnumTypeEtablissement[item].Libelle
    }
}).sort((a, b) => a.libelle.localeCompare(b.libelle));


const services = Object.keys(EnumTypeService).slice(0, 40).map(function (item, index) {
    return {
        url: '/service/type/' + EnumTypeService[item].Code + '/' + EnumTypeService[item].UrlFormate,
        libelle: EnumTypeService[item].Libelle
    }
}).sort((a, b) => a.libelle.localeCompare(b.libelle));

const demarches = [
    { url: '/infos/carte-chifa', libelle: 'Carte chifa' },
    { url: '/under', libelle: 'Assurance maladie' },
    { url: '/under', libelle: 'Allocations familiales' },
    { url: '/under', libelle: 'Hémodialyse' },
    { url: '/under', libelle: 'Maladies professionnelles' },
]

const PageAccueil = () => {

    const isMinDesktop = useMinDesktopQuery()

    return (
        <div className="page-accueil bg-grey0 flex1">
            <Helmet>
                <title>Algerie-Docto le portail algérien des médecins</title>
                <meta name="description" content="Algerie-Docto le portail des médecins et les spécialistes de la santé en Algérie" />
                <meta name="keywords" content="algerie, medecin, sante, specialiste, generaliste, urologue, neurologue, pediatre, ophtalmo" />
            </Helmet>
            <div className="banner">
                <div className="gauche">
                    <object data="/images/docto_cartoon2.svg" width="auto" height="300"> </object>
                </div>
                <div className="centre">
                    <br />
                    <h1 className="title">Le portail algérien des médecins</h1>
                    <div className="home-icon">
                        <img loading="lazy" src="/images/algeria_flag2.png" width="150" />
                    </div>
                    <div style={{ alignSelf: 'stretch' }}>
                        <SearchBar variant={isMinDesktop ? SearchBarVariants.Full : null} />
                    </div>
                    <br />
                </div>
                <MinDesktop>
                    <div className="droit">
                    </div>
                </MinDesktop>
            </div>
            <br />
            <br />
            <div className="title2">
                <FaAward color="#325288" size="38" />
                &nbsp;&nbsp;&nbsp;
               Dernières inscriptions</div>
            <CardRecemmentInscrit />

            <PanelRead>

                <CardAccueil imgSrc="/images/map_dz.png" alt="map algeria algerie docto" title="Soins dans votre wilaya" items={wilayas} />

                <CardAccueil imgSrc="/images/doctor.png" alt="specialites medicales" title="Spécialités" items={specialite} />

                <CardAccueil imgSrc="/images/etablissement.png" alt="etablissements de sante" title="Établissement" items={etablissements} />

                <CardAccueil imgSrc="/images/services_med.png" alt="service medicaux" title="Services médicaux" items={services} />

                <CardAccueil imgSrc="/images/demarches_med.png" alt="demarches et telechargments" title="Démarches & téléchargements" items={demarches} />

                <br />
                <br />
                <h1>Algerie-Docto le portail algérien de la santé</h1>
                <h2>Algerie-Docto le portail algérien des médecins et spécialistes de la santé.</h2>
                <p>
                    Algerie-Docto le portail algérien des médecins et spécialistes de la santé.
                    algerie, medecin, sante, specialiste, generaliste, pediatre, ophtalmo
                    Algerie-Docto le portail algérien des médecins

                </p>
            </PanelRead >

        </div >
    )
}

export default PageAccueil